<template>
  <div class="grid-cell">
    <span class="grid-cell--title">{{ templateDate | dateFormat }} ({{ timezoneEnv }})</span><br>
  </div>
</template>

<script>

import { systemTimezone } from '../../constants/general'
export default {
  data () {
    return {
      timezoneEnv: ''
    }
  },
  computed: {
    templateDate () {
      return this.data.updateDate ?? this.data.createDate
    }
  },
  mounted () {
    this.timezoneEnv = systemTimezone()
  }
}
</script>

<style lang="scss" scoped>
  .grid-cell {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .grid-cell--title {
    color: #000;
  }

  .grid-cell--subtitle {
    color: #666;
  }
</style>
